import React from 'react';
import { getCheckoutUrl } from '@/lib/config';
import { StatusChip } from './StatusChip';

interface Session {
  id: string;
  tenantUserId: string;
  amountUsdCents: number;
  chosenRail?: string;
  accepts: string;
  status: string;
  createdAt: number;
}

interface SessionsTableProps {
  sessions: Session[];
}

export const SessionsTable: React.FC<SessionsTableProps> = ({ sessions }) => {
  if (!sessions.length) {
    return (
      <div className='text-sm text-center py-8' style={{ color: 'var(--pp-text-subtle)' }}>
        No sessions yet
      </div>
    );
  }

  return (
    <div className='overflow-x-auto rounded-lg border' style={{ borderColor: 'var(--pp-border)' }}>
      <table className='w-full text-sm'>
        <thead>
          <tr style={{ borderBottom: `1px solid var(--pp-border)`, background: 'var(--pp-subtle)' }}>
            {['Session ID', 'User', 'Amount', 'Rail', 'Status', 'Time'].map((h) => (
              <th
                key={h}
                className='text-left px-4 py-2.5 text-xs font-medium uppercase tracking-wide'
                style={{ color: 'var(--pp-text-subtle)' }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sessions.map((s, i) => (
            <tr
              key={s.id}
              style={{
                borderBottom: i < sessions.length - 1 ? `1px solid var(--pp-border)` : 'none',
                background: i % 2 === 0 ? 'var(--pp-surface)' : 'var(--pp-bg)',
              }}
            >
              <td className='px-4 py-2.5'>
                <a
                  href={getCheckoutUrl(`/pay/${s.id}`)}
                  aria-label={`Open checkout ${s.id}`}
                  style={{ fontFamily: 'var(--pp-mono)', fontSize: '0.75rem', color: 'var(--pp-text)', textDecoration: 'none' }}
                >
                  {s.id}
                </a>
              </td>
              <td className='px-4 py-2.5' style={{ color: 'var(--pp-text-muted)' }}>
                {s.tenantUserId}
              </td>
              <td className='px-4 py-2.5'>
                <span style={{ fontFamily: 'var(--pp-mono)', fontWeight: 500, color: 'var(--pp-text)' }}>
                  ${(s.amountUsdCents / 100).toFixed(2)}
                </span>
              </td>
              <td className='px-4 py-2.5'>
                <span
                  className='text-xs font-medium uppercase'
                  style={{ color: 'var(--pp-text-muted)' }}
                >
                  {s.chosenRail ?? (s.accepts.split(',')[0] ?? '—')}
                </span>
              </td>
              <td className='px-4 py-2.5'>
                <StatusChip status={s.status} />
              </td>
              <td className='px-4 py-2.5'>
                <span style={{ fontFamily: 'var(--pp-mono)', fontSize: '0.72rem', color: 'var(--pp-text-subtle)' }}>
                  {new Date(s.createdAt * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SessionsTable;
